"use strict";

//const URL_BASE = 'https://servicos.jsoftware.com.br/api-em/' // homologacao
//const URL_BASE = 'http://localhost:5477/'
const URL_BASE = 'https://api.escalamedica.com.br/'
//const URL_BASE = 'http://ec2-18-230-113-113.sa-east-1.compute.amazonaws.com:5478'

//const accessToken = localStorage.getItem('authorization')
const VERSAO = "1.1.0.49"

export const BASE_CONSTANTS = {
    urlBase: URL_BASE,
    versao: VERSAO
}